import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "@lattice/frontend/lib/utils/ui";
import Link from "next/link";

import { routes } from "@lattice/frontend/lib/routes/routes";

export default function EtfStockMakeUpTable({ symbol }: { symbol: string }) {
  const [holdings] = trpcApi.stock.get_etf_holdings.useSuspenseQuery({
    symbol,
  });
  const [show_more, setShowMore] = React.useState(false);

  if (!holdings?.length) return;
  <p className="text-muted-foreground">No make up info available</p>;

  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead></TableHead>
            <TableHead>Symbol</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Holdings</TableHead>
            <TableHead>Number of Shares</TableHead>
            <TableHead>Market Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {holdings.slice(0, show_more ? holdings.length : 10).map((h) => (
            <TableRow key={h.name}>
              <TableCell>
                <div className="w-6 h-6 rounded-xs">
                  {h.details?.image ? (
                    <img
                      className="w-6 h-6"
                      alt={`${h.details.name} Logo`}
                      src={`data:image/png;base64,${h.details.image}`}
                    />
                  ) : (
                    <div className="bg-secondary text-secondary-foreground font-bold w-full h-full rounded-sm flex items-center justify-center text-xl">
                      {h.name.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
              </TableCell>
              <TableCell>
                <Link prefetch={false} href={routes.stock(h.asset)}>
                  {h.asset || "--"}
                </Link>
              </TableCell>
              <TableCell>{h.details?.name ?? h.name}</TableCell>
              <TableCell>{h.weightPercentage.toFixed(2)} %</TableCell>
              <TableCell>
                {new Intl.NumberFormat("en-US", {
                  notation: "compact",
                  compactDisplay: "short",
                }).format(h.sharesNumber)}
              </TableCell>
              <TableCell>
                $
                {new Intl.NumberFormat("en-US", {
                  notation: "compact",
                  compactDisplay: "short",
                }).format(h.marketValue)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {holdings.length > 6 && (
        <div className="flex justify-end mt-4 col-span-2">
          <button
            onClick={() => setShowMore((prev) => !prev)}
            className="flex items-center gap-1 text-sm text-primary hover:text-primary/80 transition-colors"
          >
            <span>{show_more ? "See Less" : "See More"}</span>
            <ChevronRight
              className={cn(
                "w-4 h-4 transition-transform",
                show_more ? "rotate-90" : "",
              )}
            />
          </button>
        </div>
      )}
    </>
  );
}
